import { render, staticRenderFns } from "./PetChangeLog.vue?vue&type=template&id=40ddcb74&scoped=true"
import script from "./PetChangeLog.vue?vue&type=script&lang=js"
export * from "./PetChangeLog.vue?vue&type=script&lang=js"
import style0 from "./PetChangeLog.vue?vue&type=style&index=0&id=40ddcb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ddcb74",
  null
  
)

export default component.exports